import { HighlightPipe } from './pipes/highlight.pipe';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '../shared/material-module';
import { ConfigEntityService } from './services/config-entity.service';
import { DeploymentService } from './services/deployment.service';
import { JobsService } from './services/jobs.service';
import { LoggerService } from './services/logger.service';
import { NavigationService } from './services/navigation.service';
import { StorageDataTransferService } from './services/storage-data-transfer.service';
import { StorageService } from './services/storage.service';
import { FileSizePipe } from './pipes/file-size.pipe';
import { SliceEmailPipe } from './pipes/slice-email.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { BooleanToString } from './pipes/boolToString.pipe';
import { NotificationService } from './services/notification.service';
import { SplitWordPipe } from './pipes/split-word.pipe';
import { NotificationTypeCheckPipe } from './pipes/notificationTypeCheck.pipe';
import { ActionLogService } from './services/action-log.service';
import { ShortTheString } from './pipes/shortenString.pipe';
import { FilterSearchPipe } from './pipes/filter-search.pipe';
import { AboutUsComponent } from './header/dialogs/about-us/about-us.component';
import { PrivacyPolicyComponent } from './header/dialogs/privacy-policy/privacy-policy.component';
import { TermsComponent } from './header/dialogs/terms/terms.component';
import { TerminalLoginDialogComponent } from './header/dialogs/terminal-login-dialog/terminal-login-dialog.component';
import { TerminalComponent } from './header/dialogs/terminal/terminal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StorageBreadcrumbPipe } from './pipes/storage-breadcrumb.pipe';
import { ManageStorageLogsService } from './services/manage-storage-logs.service';
import { TimeRemainingPipe } from './pipes/time-remaining.pipe';
import { ChangePasswordComponent } from './header/dialogs/change-password/change-password.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { MakeUpperPipe } from './pipes/make-upper.pipe';
import { ApplicationSummaryPipe } from './pipes/application-summary.pipe';
import { JobListPipe } from './pipes/job-list.pipe';
import { LogFilterPipe } from './pipes/log-filter.pipe';
import { UserFilterPipe } from './pipes/user-filter.pipe';
import { GatewayService } from './services/gateway.service';
import { LicenseServerService } from './services/license-server.service';
import { SessionService } from './services/session.service';
import { SessionListFilter } from './pipes/session-list-filter.pipe';
import { PipeModule } from './pipes/pipe.module';
import { GroupsService } from './services/groups.service';
import { ThemeService } from './services/theme.service';
import { CamelCaseConvertPipe } from './pipes/camel-case-convert.pipe';
import { NumberToStringPipe } from './pipes/number-to-string.pipe';
import { HealthService } from './services/health.service';
import { PodInfoService } from './services/pod-info.service';
import { HttpClientModule } from '@angular/common/http';
import { FunctionDispatcherService } from './services/function-dispatcher.service';

@NgModule({
  declarations: [
    FileSizePipe,
    HighlightPipe,
    SliceEmailPipe,
    SafeHtmlPipe,
    BooleanToString,
    SplitWordPipe,
    ShortTheString,
    NotificationTypeCheckPipe,
    FilterSearchPipe,
    AboutUsComponent,
    PrivacyPolicyComponent,
    TermsComponent,
    TerminalComponent,
    TerminalLoginDialogComponent,
    StorageBreadcrumbPipe,
    TimeRemainingPipe,
    ChangePasswordComponent,
    CustomDatePipe,
    MakeUpperPipe,
    ApplicationSummaryPipe,
    JobListPipe,
    LogFilterPipe,
    UserFilterPipe,
    CamelCaseConvertPipe,
    SessionListFilter,
  ],
  imports: [
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgxSpinnerModule,
    PipeModule,
    HttpClientModule
  ],
  providers: [
    StorageService,
    StorageDataTransferService,
    ConfigEntityService,
    DeploymentService,
    JobsService,
    NavigationService,
    LoggerService,
    NotificationService,
    ActionLogService,
    ManageStorageLogsService,
    GatewayService,
    LicenseServerService,
    SessionService,
    GroupsService,
    ThemeService,
    HealthService,
    PodInfoService,
    FunctionDispatcherService
  ],
  exports: [HighlightPipe, LogFilterPipe, UserFilterPipe, JobListPipe, ApplicationSummaryPipe, SliceEmailPipe, FileSizePipe, SafeHtmlPipe, BooleanToString, SplitWordPipe, NotificationTypeCheckPipe, ShortTheString, FilterSearchPipe, StorageBreadcrumbPipe, TimeRemainingPipe, CustomDatePipe, MakeUpperPipe, CamelCaseConvertPipe, SessionListFilter]
})
export class CoreModule { }
